import { proxy } from "valtio";


export const traceStore = proxy<{

  selectedTraceId: number;
  filterHttpMethod: string;
  filterStatus: string;
  filterSearch: string;
  filterEmployeeId: number;

}>({

  selectedTraceId: -1,
  filterHttpMethod: 'ALL',
  filterStatus: 'All',
  filterSearch: '',
  filterEmployeeId: -1,

});
export default traceStore;



